import React, { Component } from 'react';
import { connect } from 'react-redux';
import BounceEmails from './bounceEmails';
import BlockUi from 'react-block-ui';
import { Loader } from 'react-loaders';

@connect(
  state=>state.tenant,
  null
)
class bounceEmailCon extends Component{
  componentDidMount() {
    $("#activity, #project-context").show();
  }
  render() {
    let block = !this.props.tenantInfo.name;
    return (
      <BlockUi tag="div"
               blocking={block}
               loader={<Loader active type="ball-grid-pulse" color="#808080"/>}
               renderChildren={false}>
        <BounceEmails />
      </BlockUi>
    );
  }
}

export default bounceEmailCon;


// WEBPACK FOOTER //
// ./src/container/dashboard/model/bounceEmailCon.js